module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAABNUlEQVQokYXQv6vPURzH8cf3+ioZbpRkoCtWKd7vskrJcDPe4TswKJsy3sVyFxa7OwuLMtxBpL7/gPctRboWyaZYKD8Kx+Bzbyffi1ed4fQ6z/Oq56i1pk9mruAC5vCkqi7bJqMezMxVXMJ5fMF9TKtqMvQnsLeqpltgZh7CaxytqrfdZ29wDp9xGwexNO7W9+B9Dw15h51YxHHswvLcZltVz4eFO93aNRzGRlWtYg1Pq2rSL8JZPMzMR/iGU1iqqu9DfwO7Z+T8IWkeK1X1auZBD2bmEdzEAXzAT+zDDqxV1fUZMDMnuOe3/rt4hq/Yj9NYxo+qWtgiI+JkRLSIuNha87cTES8i4vHmXUSsR8Stf0Ed/DEizrTWjHEMVzNzHqPtRAz5hJe4gukYG4Pm/6UNsh7AL9ygprLQisyjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reg_2.png
// module id = npT7
// module chunks = 1